export default __webpack_public_path__ + "static/media/logo.2c02b9b1.svg";